"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _publish = _interopRequireDefault(require("./publish"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Tracker = /*#__PURE__*/function () {
  function Tracker(_ref) {
    var _window$inSidedData$p, _window$inSidedData, _window$inSidedData$p2;

    var map = _ref.map,
        breadcrumbData = _ref.breadcrumbData;
    (0, _classCallCheck2.default)(this, Tracker);
    this.customerMap = map;
    this.breadcrumbData = breadcrumbData;
    this.ignoredLinks = ['/', '/community', '/knowledge-base'];
    this.modules = ['/community', '/knowledge-base', '/groups', '/events', '/product-updates', '/ideas']; // eslint-disable-next-line no-restricted-properties

    var data = _objectSpread({}, window.inSidedData);

    data.page.url = window.location.pathname.substr(1);
    data.content.post.id = data.content.topic.id && window.location.hash ? window.location.hash.substr(5) : null;
    data = this.enrichData(data); // eslint-disable-next-line no-restricted-properties

    var skipPageview = (_window$inSidedData$p = (_window$inSidedData = window.inSidedData) === null || _window$inSidedData === void 0 ? void 0 : (_window$inSidedData$p2 = _window$inSidedData.params) === null || _window$inSidedData$p2 === void 0 ? void 0 : _window$inSidedData$p2.skipPageview) !== null && _window$inSidedData$p !== void 0 ? _window$inSidedData$p : false;

    if (!skipPageview) {
      setTimeout(function () {
        _publish.default.trackEvent('pageview', data);
      });
    }

    document.dispatchEvent(new window.CustomEvent('insided:track', {
      detail: this.mapData(data)
    }));
  }

  (0, _createClass2.default)(Tracker, [{
    key: "mapData",
    value: function mapData(data) {
      var _this = this;

      if (!this.customerMap) return data;

      var _loop = function _loop(key) {
        var val = _this.customerMap[key];
        if (!val) return "continue";
        var customerDataValue = data;
        val.split('.').forEach(function (path) {
          var _customerDataValue$pa;

          customerDataValue = (_customerDataValue$pa = customerDataValue[path]) !== null && _customerDataValue$pa !== void 0 ? _customerDataValue$pa : '';
        });
        if (!customerDataValue) return "continue";
        data[key] = customerDataValue;
      };

      for (var key in this.customerMap) {
        var _ret = _loop(key);

        if (_ret === "continue") continue;
      }

      return data;
    }
  }, {
    key: "enrichData",
    value: function enrichData(data) {
      var _data$content,
          _data$content$topic,
          _data$content2,
          _data$content2$catego,
          _this2 = this;

      // We do not want any category filter on search when user is on topic page
      if (!((_data$content = data.content) !== null && _data$content !== void 0 && (_data$content$topic = _data$content.topic) !== null && _data$content$topic !== void 0 && _data$content$topic.id) && (_data$content2 = data.content) !== null && _data$content2 !== void 0 && (_data$content2$catego = _data$content2.category) !== null && _data$content2$catego !== void 0 && _data$content2$catego.id) {
        var _moduleName$url$repla, _moduleName$url;

        data.search.categoryPath = this.breadcrumbData.filter(function (breadcrumbData) {
          return !_this2.ignoredLinks.includes(breadcrumbData.url);
        }).map(function (breadcrumbData) {
          var _breadcrumbData$title;

          return (_breadcrumbData$title = breadcrumbData.title) === null || _breadcrumbData$title === void 0 ? void 0 : _breadcrumbData$title.trim();
        }).join(' > ');
        var moduleName = this.breadcrumbData.find(function (breadcrumbData) {
          return _this2.modules.includes(breadcrumbData.url);
        }); // If there is a category but no matching on module url, it should be community category

        data.search.module = (_moduleName$url$repla = moduleName === null || moduleName === void 0 ? void 0 : (_moduleName$url = moduleName.url) === null || _moduleName$url === void 0 ? void 0 : _moduleName$url.replace('/', '')) !== null && _moduleName$url$repla !== void 0 ? _moduleName$url$repla : 'community';
      }

      if (data.content.topic.id) {
        var _cookies$getJSON;

        var topics = (_cookies$getJSON = _jsCookie.default.getJSON('topics')) !== null && _cookies$getJSON !== void 0 ? _cookies$getJSON : [];

        if (!topics.includes(data.content.topic.id)) {
          data.page.firstRender = true;
          topics.push(data.content.topic.id);

          _jsCookie.default.set('topics', topics.slice(-19), {
            expires: 2
          });
        }
      }

      return data;
    }
  }]);
  return Tracker;
}();

module.exports = function (options) {
  return new Tracker(options);
};